export const HelmetConfig = {
	googleSiteVerification: 'iSBMfBvdSuUh7JVPalh9GbrIJ4np8OQNAGC23VorDYA',
	msValidate1: '72430AA401040F456AF99A586F12B284'
};
